export default function mapLegacyFiltersToBuildFilters(accounts = [], writers = [], songs = []) {
  const accountFilters = accounts.map(account => ({
    type: "Account",
    value: account,
  }));

  const writerFilters = writers.map(writer => ({
    type: "Writer",
    value: writer,
  }));

  const songFilters = songs.map(song => ({
    type: "Song",
    value: song,
  }));

  return [...accountFilters, ...writerFilters, ...songFilters];
}
